import { z } from "zod";
import { LinkedButtonWhenEnumSchema } from "../Enums/LinkedButtonWhenEnum";
import { RequestSectionContainerLayoutEnumSchema } from "../Enums/RequestSectionContainerLayout";
import { SectionOrFieldGroupDto, SectionOrFieldGroupDtoSchema } from "./SectionOrFieldGroupDto";
import { LinkedOdvetvieIdDtoSchema } from "./LinkedOdvetvieIdDto";
import { SectionDisplayTypeEnumSchema } from "../Enums/SectionDisplayTypeEnum";

const BaseRequestParameterSectionDtoSchema = z.object({
    id: z.string(),
    requestTypeStepId: z.string(),
    parentSectionId: z.string().nullish(),
    requestTypeId: z.number(),
    order: z.number(),
    width: z.number().nullish(),
    name: z.string().nullish(),
    displayTitle: z.string().nullish(),
    reactIcon: z.string().nullish(),
    displayType: SectionDisplayTypeEnumSchema.nullish(),
    borderWidth: z.number(),
    borderTop: z.boolean(),
    borderRight: z.boolean(),
    borderBottom: z.boolean(),
    borderLeft: z.boolean(),
    borderColor: z.string().nullish(),
    backgroundColor: z.string().nullish(),
    fontColor: z.string().nullish(),
    layout: RequestSectionContainerLayoutEnumSchema.nullish(),
    layoutMobile: RequestSectionContainerLayoutEnumSchema.nullish(),
    flex: z.string().nullish(),
    flexMobile: z.string().nullish(),
    htmlBeforeField: z.string().nullish(),
    linkedButtonKey: z.string().nullish(),
    linkedButtonWhen: LinkedButtonWhenEnumSchema.nullish(),
    linkedOdvetvie: z.array(LinkedOdvetvieIdDtoSchema),
    collapsible: z.boolean(),
    isCollapsedByDefault: z.boolean(),
    infoText: z.string().nullish(),
    collapsed: z.boolean().nullish() // Added by FE,
});

export type RequestParameterSectionDto = z.infer<typeof BaseRequestParameterSectionDtoSchema> & {
    children: SectionOrFieldGroupDto[];
}

// Cast needed: z.lazy() + extend loses required `children` in Zod's inferred output under z.ZodType<T>.
export const RequestParameterSectionDtoSchema: z.ZodType<RequestParameterSectionDto> =
    BaseRequestParameterSectionDtoSchema.extend({
        children: z.lazy(() => SectionOrFieldGroupDtoSchema.array()),
    }) as z.ZodType<RequestParameterSectionDto>;